$(document).ready(function(){
  $('.product-grid-item .img-full').mouseenter(function(){
    //$(this).addClass('hovered');
    //var altImage = $(this).next();
    //var currentUrl = $(this).attr('src');
    //var newUrl = altImage.attr('src');
    //$(this).addClass('img-hidden');
    //altImage.removeClass('img-hidden');
  });
});